import styled from 'styled-components'

import { type ITableCustomFieldProps } from '../TableCustomField'

export const TableCustomFieldStyled = styled.span<
  Partial<ITableCustomFieldProps>
>`
  font-size: ${(props) => props.theme.typography.pxToRem(12)};
`
TableCustomFieldStyled.displayName = 'TableCustomFieldStyled'
